/* eslint-disable */
// Generated at build time by scripts/gen-aws-exports.mjs from amplify_outputs.json
const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cloud_logic_custom": [
    {
      "name": "ckprivateapi",
      "endpoint": "https://czzmml1kvk.execute-api.us-east-1.amazonaws.com/prod",
      "region": "us-east-1"
    },
    {
      "name": "ckpublicapi",
      "endpoint": "https://ak52wnkvtg.execute-api.us-east-1.amazonaws.com/prod",
      "region": "us-east-1"
    }
  ],
  "aws_cognito_identity_pool_id": "us-east-1:ddfd52a9-7a92-457e-9a4b-12ff18789ac0",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_9eYnpQLRg",
  "aws_user_pools_web_client_id": "2el17l9ov9dcg4feknlqk9ih5i",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ]
};
export default awsmobile;
